module.exports = __webpack_public_path__ + "img/img_kginicis.67bc6fc6.png";